/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as artistActions from '../../actions/artistActions';
import * as modalActions from '../../actions/modalActions';
import * as trackActions from '../../actions/trackActions';
import * as videoActions from '../../actions/videoActions';
import ArtistService from '../../services/artistService.js';
import urls from '../../constants/urls.js';
import MetaTags from 'react-meta-tags';
import FacebookLike from '../common/FacebookLike.js';
import TwitterFollow from '../common/TwitterFollow.js';
import GetToKnowMe from './GetToKnowMe';
import HearMe from './HearMe';
import WatchMe from './WatchMe';
import SeeMe from './SeeMe';
import FindMe from './FindMe';
import BuyMe from './BuyMe';
import ChatToMe from './ChatToMe';
import ChatToMeConversation from './ChatToMeConversation';
import Connections from './Connections';
import * as browserCheck from '../../utils/browserCheck.js';
import PageLoading from '../common/PageLoading';
import NotFound from '../common/NotFound';
import Error from '../common/Error';
import Modal from '../common/Modal';
import modalTypes from '../../constants/modalTypes.js';
import WidgetService from '../../services/widgetService.js';
import ShareService from '../../services/shareService.js';
import trimStart from 'lodash/trimStart';
import ToastrService from '../../services/toastrService';

class ProfilePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.showConnectionsInbound = this.showConnectionsInbound.bind(this);
        this.showConnectionsOutbound = this.showConnectionsOutbound.bind(this);
        this.connectDisconnect = this.connectDisconnect.bind(this);
        this.getPlugInText = this.getPlugInText.bind(this);
        this.getPlugInTooltip = this.getPlugInTooltip.bind(this);
        this.isPluggedIn = this.isPluggedIn.bind(this);
        this.getNoProfileComponent = this.getNoProfileComponent.bind(this);
        this.getConversationModalHeader = this.getConversationModalHeader.bind(this);
        this.setGalleryRef = this.setGalleryRef.bind(this);
        this.getTweetUrl = this.getTweetUrl.bind(this);
        this.getShareUrl = this.getShareUrl.bind(this);
        this.getEmailUrl = this.getEmailUrl.bind(this);
        this.getTabFunction = this.getTabFunction.bind(this);
        this.isPlugInButtonEnabled = this.isPlugInButtonEnabled.bind(this);

    }

    componentWillMount() {
        const currentProfileID = this.props.user && this.props.user.activeProfile ? this.props.user.activeProfile.ID : null;
        this.props.actions.getProfile(this.props.match.params.username, currentProfileID, this.getTabFunction(), this.props.match.params.tabName);
        this.props.actions.hideModal();        
    }

    componentDidMount() {   
        $('#btn-plugin').tooltip();
        this.initPhotoGallery();
    }

    componentWillReceiveProps(nextProps) {
        let hideModals = false;
        const profileUpdated = this.props.match.params.username != nextProps.match.params.username;
        const currentProfileID = this.props.user && this.props.user.activeProfile ? this.props.user.activeProfile.ID : null;            
        const newCurrentProfileID = nextProps.user && nextProps.user.activeProfile ? nextProps.user.activeProfile.ID : null;
        const currentProfileUpdated = currentProfileID != newCurrentProfileID;
        const currentProfileSet = !currentProfileID && newCurrentProfileID;
            
        if(profileUpdated || currentProfileSet || currentProfileUpdated) {
            this.props.actions.getProfile(nextProps.match.params.username, newCurrentProfileID, this.getTabFunction(), this.props.match.params.tabName);          
            hideModals = true;            
        }        
        if(this.props.match.params.tabName != nextProps.match.params.tabName) {
            hideModals = true;
        }
        if(hideModals) {
            this.props.actions.hideModal();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.artist != null && (prevProps.artist == null || this.props.artist.Images != prevProps.artist.Images)) {
            this.initPhotoGallery();
        }
        //we need to also handle the case where we connect/disconnect?
        const pluginButton = $('#btn-plugin');
        const titleUpdated = pluginButton.attr('title') != '' && pluginButton.attr('title') != pluginButton.attr('data-original-title');
        const profileUpdated = this.props.match.params.username != prevProps.match.params.username;
        const activeProfileUpdated = this.props.user && this.props.user.activeProfile && prevProps.user && prevProps.user.activeProfile && this.props.user.activeProfile.ID != prevProps.user.activeProfile.ID;
        const connectionsUpdated = this.props.artist && prevProps.artist && (this.props.artist.PluggedIn !== prevProps.artist.PluggedIn || this.props.artist.PluggedInto !== prevProps.artist.PluggedInto);
        if(titleUpdated || profileUpdated || activeProfileUpdated) {
            const pluginButton = $('#btn-plugin');
            if(pluginButton.attr('title') != '') {
                pluginButton.attr('data-original-title', pluginButton.attr('title'));
                pluginButton.tooltip();
                pluginButton.attr('title', '');
            }            
        }  
        if(connectionsUpdated) {            
            const pluginButton = $('#btn-plugin');
            //if the tooltip is visible, change the visible text
            pluginButton.next().find('.tooltip-inner').text(pluginButton.attr('data-original-title'));           
        }  
    }

    getTabFunction() {
        switch(this.props.match.params.tabName) {
            case 'GetToKnowMe':
            case null:
            case undefined:
            case '':
                return this.props.actions.getBio;
            case 'HearMe':
                return this.props.actions.getMusic;
            case 'WatchMe':
                return this.props.actions.getVideos;
            case 'SeeMe':
                return this.props.actions.getGigs;
            case 'BuyMe':
                return this.props.actions.getBuyOptions;
            case 'FindMe':
                return this.props.actions.getAddress;
            case 'ChatToMe':
                return (username) => this.props.actions.getComments(username, true);
            default:
                return null;
        }           
    }

    setGalleryRef(galleryRoot) {
        this.galleryRoot = galleryRoot;
    }

    getNoProfileComponent() {
        if(this.props.profileLoadingStatus == 'LOADING') {
            return <PageLoading />;
        }
        else if(this.props.profileLoadingStatus == 'FAILED') {
            return <Error />;
        }
        else {
            return <NotFound />;
        }
    }

    getConversationModalHeader() {
        if(this.props.artist.Conversation && this.props.artist.Conversation.Conversation && this.props.artist.Conversation.Conversation.length) {
            const conversation = this.props.artist.Conversation;
            return `Conversation: ${conversation.DisplayName} and ${conversation.DisplayNameCounter}`;
        }
        else if(this.props.artist.ConversationStatus === 'FAILED') {
            return 'Unable to load conversation';
        }
        else {
            return 'Loading conversation...';
        }
    }

    getGenreText() {
        let genreText = '';
        const genres = this.props.artist.Genres;
        if(genres.length === 1) {
            genreText = genres[0];
        }
        else if(genres.length > 1) {
            for(let i = 0; i < genres.length; i++) {
                genreText += genres[i];
                if(i < genres.length - 1 && i < 2) {
                    genreText += '/';
                }
                if(i === 2) {
                    break;
                }
            }
        }
        return genreText;
    }

    getRoleTypeFriendlyName() {
        if(this.props.artist) {
            return ArtistService.getRoleTypeFriendlyName(this.props.artist.RoleType);
        }
        else {
            return '';
        }
    }

    getTitle() {
        const artist = this.props.artist;
        if(artist) {
            switch(this.props.match.params.tabName) {
                case 'GetToKnowMe':
                    return `${artist.Name} on LoudUp`;
                case 'HearMe':
                    if(artist.RoleType == 'Fan') {
                        return `Listen to music rated by ${artist.Name} on LoudUp`;
                    }
                    else {
                        return `Listen to music by ${artist.Name} on LoudUp`;
                    }
                case 'WatchMe':
                    if(artist.RoleType == 'Fan') {
                        return `Watch music videos rated by ${artist.Name} on LoudUp`;
                    }
                    else {
                        return `Watch music videos by ${artist.Name} on LoudUp`;
                    }
                case 'SeeMe':
                    return `View upcoming gigs by ${artist.Name} on LoudUp`;
                case 'BuyMe':
                    return `Buy music by ${artist.Name} on LoudUp`;
                case 'FindMe':
                    return `Find the location of ${artist.Name} on LoudUp`;
                case 'ChatToMe':
                    return `Chat to ${artist.Name} on LoudUp`;
                default:
                    return `${artist.Name} on LoudUp`;
            }
        }
        else {
            return '';
        }
    }

    getMetaDescription() {
        const artist = this.props.artist;
        if(artist) {
            let genreText = this.getGenreText();
            switch(this.props.match.params.tabName) {
                case 'GetToKnowMe':
                    return this.getShareDescription(artist);
                case 'HearMe':
                    if(artist.RoleType == 'Fan') {
                        return `Listen to the tracks that have been rated by ${artist.Name} (${genreText} Music Fan) on LoudUp`;
                    }
                    else {                    
                        if(genreText) {
                            return `Listen to tracks by ${artist.Name} (${genreText} ${this.getRoleTypeFriendlyName()}) on LoudUp`;
                        }
                        else {
                            return `Listen to tracks by ${artist.Name} (${this.getRoleTypeFriendlyName()}) on LoudUp`;
                        }
                    }
                case 'WatchMe':
                    if(artist.RoleType == 'Fan') {
                        return `Watch music videos that have been rated by ${artist.Name} (${genreText} Music Fan) on LoudUp`;
                    }
                    else {                    
                        if(genreText) {
                            return `Watch music videos by ${artist.Name} (${genreText} ${this.getRoleTypeFriendlyName()}) on LoudUp`;
                        }
                        else {
                            return `Watch music videos by ${artist.Name} (${this.getRoleTypeFriendlyName()}) on LoudUp`;
                        }
                    }
                case 'SeeMe':
                    return `Browse the upcoming gigs by ${artist.Name} (${genreText} ${this.getRoleTypeFriendlyName()}) on LoudUp`;
                case 'BuyMe':
                    return `Find out how to buy music by ${artist.Name} (${genreText} ${this.getRoleTypeFriendlyName()}) on LoudUp`;
                case 'FindMe':
                    return `"View the location of ${artist.Name} (${this.getRoleTypeFriendlyName()}) on LoudUp`;
                case 'ChatToMe':
                    if(genreText) {
                        return `Send a comment or private message to ${artist.Name} (${genreText} ${this.getRoleTypeFriendlyName()}) on LoudUp`;
                    }
                    else {
                        return `Send a comment or private message to ${artist.Name} (${this.getRoleTypeFriendlyName()}) on LoudUp`;
                    } 
                default:
                    return '';
            }
        }
        else {
            return '';
        }
    } 

    getShareDescription() {
        const artist = this.props.artist;
        if(artist) {
            const musicVisible = ArtistService.showMusic(artist.RoleType);
            const videosVisible = ArtistService.showVideos(artist.RoleType);
            const genreText = this.getGenreText();
            const roleTypeFriendlyName = this.getRoleTypeFriendlyName();
            if (artist.roleType != 'Fan' && musicVisible && videosVisible)
            {
                return `Check out music and videos by ${artist.Name} (${genreText} ${roleTypeFriendlyName}) on LoudUp - Music Social Network`;
            }
            else if (artist.roleType != 'Fan' && musicVisible)
            {
                return `Check out music by ${artist.Name} (${genreText} ${roleTypeFriendlyName}) on LoudUp - Music Social Network`;
            }
            else if (artist.roleType != 'Fan' && videosVisible)
            {
                return `Check out videos by ${artist.Name} (${genreText} ${roleTypeFriendlyName}) on LoudUp - Music Social Network`;
            }
            else if(artist.roleType == 'Fan')
            {
                return `Check out ${artist.Name} (${genreText} Music ${roleTypeFriendlyName}) on LoudUp - Music Social Network`;
            }
            else
            {
                return `Check out ${artist.Name} (${roleTypeFriendlyName}) on LoudUp - Music Social Network`;
            }
        }
    }
    
    initPhotoGallery() {
        if(this.props.artist) {
            const items = this.props.artist.Images.map((image) =>
            {
                return {
                    src: `${urls.USER_IMAGES_BASE_URL}${image.Path}?maxwidth=800&maxheight=650`,
                    title: image.Name
                };
            });
            if(items.length > 1) {
                WidgetService.initialiseMagnificGallery($(this.galleryRoot), items);  
            }
        }      
    }
    
    showGenre() {
        return this.props.artist && ArtistService.showGenre(this.props.artist.RoleType);
    }

    showInstrument() {
        return this.props.artist && ArtistService.showInstrument(this.props.artist.RoleType);
    }

    showCapacity() {
        return this.props.artist && ArtistService.showCapacity(this.props.artist.RoleType);
    }

    showRating() {
        return this.props.artist && ArtistService.showRating(this.props.artist.RoleType);      
    }

    showConnectionsInbound(event) {    
        event.preventDefault();
        this.props.actions.getConnections(this.props.artist.Username, true);
        this.props.actions.showModal(modalTypes.PLUGGED_IN);
    }

    showConnectionsOutbound(event) {
        event.preventDefault();
        this.props.actions.getConnections(this.props.artist.Username, false);
        this.props.actions.showModal(modalTypes.PLUGGED_INTO);
    }

    showLike() {
        return this.props.artist && this.props.artist.FacebookPageUrl && this.props.artist.RoleType != 'Fan';
    }

    showFollow() {
        return this.props.artist && this.props.artist.TwitterUsername;
    }

    isPluggedIn(roleID = this.props.artist ? this.props.artist.RoleID : null) {
        let pluggedIn = false;
        if(this.props.user && this.props.user.activeProfile && roleID) {
            pluggedIn = this.props.user.activeProfile.OutboundConnections.find(id => id == roleID) != null;
        }
        return pluggedIn;
    }

    getPlugInTooltip(roleID = this.props.artist ? this.props.artist.RoleID : null) {
        let plugInTooltip;
        if (this.isPluggedIn(roleID)) {                
            plugInTooltip = "Click to unplug";
        }
        else {
            if(this.props.user && this.props.user.activeProfile && roleID && this.props.user.Profiles.find(p => p.ID == roleID) != null) {
                plugInTooltip = "You cannot plug into your own profile";
            }
            else if(this.props.user && this.props.user.Confirmed && this.props.user.activeProfile) {
                plugInTooltip = "Plug in to see my updates";
            }
            else if(!this.props.user) {
                plugInTooltip = "Log in to plug in and see my updates";
            }    
            else if(!this.props.user.activeProfile) {
                plugInTooltip = "Create a profile to plug in and see my updates";
            }   
            else if(!this.props.user.Confirmed) {
                //order here is important. we set the confirmed flag on the role so it's important to check if there's a role 1st so we're showing the correct message
                plugInTooltip = "Please confirm your email address to plug in and see my updates";
            }
        }      
        return plugInTooltip;
    }

    getPlugInText(roleID = this.props.artist ? this.props.artist.RoleID : null) {
        return this.isPluggedIn(roleID) ? "PLUGGED IN" : "PLUG IN";
    }

    isPlugInButtonEnabled(roleID = this.props.artist ? this.props.artist.RoleID : null) {
        if(!this.props.user || !this.props.user.activeProfile || !this.props.user.Confirmed) {
            return false;
        }   
        else if(!roleID || this.props.user.Profiles.find(p => p.ID == roleID) != null) {
            //no role ID or it's our own role
            return false;
        }
        return true;
    }

    connectDisconnect(event, artist = this.props.artist) {
        if(artist && this.props.user && this.props.user.activeProfile) {
            if(this.isPlugInButtonEnabled(artist.RoleID)) {
                const activeProfile = this.props.user.activeProfile;
                const toastrService = new ToastrService();
                if(this.isPluggedIn(artist.RoleID)) {
                    //disconnect
                    this.props.actions.deleteConnection(activeProfile.Username, artist.RoleID)
                        .then(connection => {
                            toastrService.showSuccess('', `You have been unplugged from ${artist.Name}`);
                        })
                        .catch(error => {
                            toastrService.showError('', 'Sorry, something went wrong, please try again');
                        });
                }
                else {
                    //connect
                    this.props.actions.addConnection(activeProfile.Username, artist.RoleID)
                    .then(connection => {
                        toastrService.showSuccess('', `You are now plugged into ${artist.Name}`);
                    })
                    .catch(error => {
                        toastrService.showError('', 'Sorry, something went wrong, please try again');
                    });
                }
            }
            else {
                const toastrService = new ToastrService();
                toastrService.showError('', this.getPlugInTooltip(artist.RoleID));
            }
        }
    }

    getTweetUrl() {
        return ShareService.getTwitterShareUrl(this.props.match.url, `Check out this great ${this.getRoleTypeFriendlyName().toLowerCase()} - ${this.props.artist ? this.props.artist.Name : ''}`);
    }

    getShareUrl() {
        return ShareService.getFacebookShareUrl(this.props.match.url);
    }

    getEmailUrl() {
        const body = `${ShareService.getAbsoluteUrl(this.props.match.url)}%0A%0AShared from LoudUp`;
        const subject = `Check out this great ${this.getRoleTypeFriendlyName().toLowerCase()} - ${this.props.artist ? this.props.artist.Name : ''}`;
        return ShareService.getEmailShareUrl(subject, body);
    }

    getTabClass(tabName) {
        let pageTabName = this.props.match.params.tabName || 'GetToKnowMe';
        return tabName.toLowerCase() == pageTabName.toLowerCase() ? 'active':'';
    }

    getTabUrl(tabName) {
        if(this.props.artist) {
            //return `${this.props.artist.Username}`;
            return `/${this.props.artist.Username}/${tabName}`;
        }
        else {
            return '';
        }
    }

    getTabContent() {
        const activeProfile = this.props.user ? this.props.user.activeProfile : null;
        if(!this.props.match.params.tabName || this.props.match.params.tabName.toLowerCase() == 'gettoknowme') {
            return <GetToKnowMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'hearme') {
            return <HearMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'watchme') {
            return <WatchMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'seeme') {
            return <SeeMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'buyme') {
            return <BuyMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'findme') {
            return <FindMe artist={this.props.artist} actions={this.props.actions} activeProfile={activeProfile} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'chattome') {
            return <ChatToMe artist={this.props.artist} user={this.props.user} activeProfile={activeProfile} actions={this.props.actions} />;
        }                                                
    }

    getDefaultImage(params) {
        if(this.props.artist) {
            if(this.props.artist.Images.length > 0) {
                return urls.USER_IMAGES_BASE_URL + this.props.artist.Images[0].Path + (params || '');
            }
            else {
                let defaultImage = `${ArtistService.getDefaultImage(this.props.artist.RoleType)}`;
                if(params) {
                    if(defaultImage.indexOf('?') > -1) {
                        defaultImage = `${defaultImage}&${trimStart(params, '?')}`;
                    }
                    else {
                        defaultImage += params;
                    }
                }
                return defaultImage;
            }
        }
        return null;
    }

    render() {   
        const url = ShareService.getAbsoluteUrl(`/${this.props.match.params.username}`);    
        return (
            <div id="content">
                {this.props.artist ?
                    <div>
                        <MetaTags>
                            <title>{this.getTitle()}</title>
                            <meta id="og-image" property="og:image" content={this.getDefaultImage() || ''} />
                            <meta id="description" name="description" content={this.getMetaDescription()} />
                            <meta id="og-title" property="og:title" content={this.props.artist.Name} />
                            <meta id="og-description" property="og:description" content={this.getShareDescription()} />
                            <meta id="og-type" property="og:type" content="website" />
                            <meta id="og-url" property="og:url" content={url} />  
                            <meta id="twitter-url" name="twitter:url" content={url} />   
                            <meta id="twitter-title" name="twitter:title" content={this.props.artist.Name || ''} />   
                            <meta id="twitter-description" name="twitter:description" content={this.getShareDescription()} />   
                            <meta id="twitter-image" name="twitter:image" content={this.getDefaultImage() || ''} />
                            <meta name="robots" content={this.props.artist.ShouldIndex ? 'index' : 'noindex'} />                            
                        </MetaTags>
                        {this.props.match.params.tabName == 'GetToKnowMe' ? <link rel="canonical" href={url} /> : null}
                        <div className="promo promo-profile">
                            <div className="container">
                                <div className="block-inner">
                                    <div className="row mainrow">
                                        <div className="col-md-7 maincol">
                                            <div className="top-out">
                                                <div className="top-artist profile-img">
                                                    {this.props.artist && this.props.artist.Images.length > 1 ?
                                                        <a id="photoGallery" href="#" className="btn-photogal transition" ref={this.setGalleryRef}>
                                                            <svg className="icon icn-photo transition">
                                                                <use xlinkHref="#icn-camera" />
                                                            </svg>
                                                            <span>{` ${this.props.artist.Images.length || 0}`}</span>
                                                        </a> : null}
                                                    <div className="imgbox">
                                                        {this.props.artist ? <img id="imgMainProfile" className="slimmage" src={this.getDefaultImage('?width=480&aspectw=1.5&quality=80&mode=crop&scale=both&format=jpg') || ''} alt={this.props.artist.Name} style={{maxWidth:'100%'}} /> :null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5 maincol">
                                            <div className="artist-info">
                                                <div className="infobox">
                                                    <h1>{this.props.artist ? this.props.artist.Name : ''}</h1>
                                                    <p className="arttype">{this.getRoleTypeFriendlyName()} <span className="delimiter">&middot;</span>{this.showInstrument() ? <span> {this.props.artist.Instrument + " - " + this.props.artist.Expertise} <span className="delimiter">&middot;</span></span> : ''} Joined {new Date(this.props.artist.JoinDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'short' })}</p>
                                                    {this.showGenre() ?
                                                        <p className="genres">
                                                            {this.props.artist.Genres.slice(0, 5).map((genre) =>                        
                                                                <Link to={`/${this.props.artist.RoleType == 'Producer' ? 'Producer' : 'Artist'}s/${genre}`} key={genre}>
                                                                    <span className="badge">{genre}</span>
                                                                </Link>
                                                            )}
                                                        </p> : <br />
                                                    }                 
                                                    <ul className="list-unstyled list-stats">                                                        
                                                        {this.showCapacity() ?
                                                            <li>
                                                                <p className="list-stats-name">Capacity</p>
                                                                <p className="list-stats-val">{this.props.artist.Capacity}</p>                
                                                            </li> : null
                                                        }
                                                        {this.showRating() ?
                                                            <li>
                                                                <p className="list-stats-name">Rating</p>
                                                                <p className="list-stats-val">{this.props.artist.Rating}<span className="small">dB</span></p>
                                                            </li> : null
                                                        }                         
                                                        <li>
                                                            <p className="list-stats-name">Views</p>
                                                            <p className="list-stats-val">{this.props.artist ? this.props.artist.ViewCount : 0}</p>
                                                        </li>  
                                                        <li>
                                                            <p className="list-stats-name">Plugged In</p>
                                                            <a href="#" className="list-stats-val" onClick={this.showConnectionsInbound}>{this.props.artist ? this.props.artist.PluggedIn : 0}</a>
                                                        </li>
                                                        <li>
                                                            <p className="list-stats-name">Plugged Into</p>
                                                            <a href="#" className="list-stats-val" onClick={this.showConnectionsOutbound}>{this.props.artist ? this.props.artist.PluggedInto : 0}</a>
                                                        </li>   
                                                    </ul>
                                                    <div id="plug-btns" className={`plug-btns ${this.props.artist && this.props.artist.RoleType == 'Fan' ? 'singlebtn' : ''}`}>
                                                        <button id="btn-plugin" className={`btn btn-primary btn-plug transition btn-50 tip ${this.isPluggedIn() ? 'btn-active' : ''}`} data-toggle="tooltip" data-placement="top" title={this.getPlugInTooltip()} onClick={this.connectDisconnect}>
                                                            <svg className="icon icn-plug">
                                                                <use xlinkHref="#icn-plug" />
                                                            </svg>
                                                            <span id="buttonText">{this.getPlugInText()}</span>
                                                        </button>
                                                        <div className="dropdown btn-50">                                                    
                                                            {this.props.artist && this.props.artist.RoleType != 'Fan' ?
                                                                <button id="btn-share" className="btn btn-primary btn-share transition" role="button" data-toggle="dropdown">
                                                                    <svg className="icon icn-share">
                                                                        <use xlinkHref="#icn-share" />
                                                                    </svg>
                                                                    SHARE
                                                                </button>: null
                                                            }
                                                            <ul id="sharebox1" className="dropdown-menu share" role="menu" aria-labelledby="drop6">
                                                                <li><a href={this.getTweetUrl()} className="first transition" target="_blank">
                                                                    <img src={require('../../images/icon-tweet.png')} width="59" height="20" alt="Tweet" />TWEET ME</a>
                                                                </li>
                                                                <li><a href={this.getShareUrl()} className="transition" target="_blank">
                                                                    <img src={require('../../images/icon-share.png')} width="57" height="18" alt="Share" />SHARE ME</a></li>
                                                                <li><a href={this.getEmailUrl()} className="transition">
                                                                    <img src={require('../../images/icon-email.png')} width="59" height="20" alt="Email" />EMAIL ME</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                        </div>
                        <div className="main">
                            <div className="container">
                                <div className="block-inner">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="tabs-stacked tabbed-content-profile">
                                                <ul id="profileTabs" className="nav nav-tabs" role="tablist">
                                                    <li className={this.getTabClass('GetToKnowMe')}>
                                                        <Link id="lnkGetToKnowMe" className="transition" to={this.getTabUrl('GetToKnowMe')}>
                                                            <svg className="icon icon-tab transition">
                                                                <use xlinkHref="#icn-about" />
                                                            </svg>
                                                            <span className="title"> Get to know me</span>
                                                        </Link>
                                                    </li>

                                                    {this.props.artist && ArtistService.showMusic(this.props.artist.RoleType)
                                                    ?
                                                        <li className={this.getTabClass('HearMe')}>
                                                            <Link id="lnkHearMe" className="transition" to={this.getTabUrl('HearMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-music" />
                                                                </svg>
                                                                <span className="title"> {this.props.artist.RoleType != 'Fan' ? 'Hear me' : 'Hear with me'}</span>
                                                            </Link>
                                                        </li> : null}
                                                    {this.props.artist && ArtistService.showVideos(this.props.artist.RoleType)
                                                    ?
                                                        <li className={this.getTabClass('WatchMe')}>
                                                            <Link id="lnkWatchMe" className="transition" to={this.getTabUrl('WatchMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-tv" />
                                                                </svg>
                                                                <span className="title"> {this.props.artist.RoleType != 'Fan' ? 'Watch me' : 'Watch with me'}</span>
                                                            </Link>
                                                        </li> : null}
                                                    {this.props.artist && ArtistService.showGigs(this.props.artist.RoleType)
                                                    ?
                                                        <li className={this.getTabClass('SeeMe')}>
                                                            <Link id="lnkSeeMe" className="transition" to={this.getTabUrl('SeeMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-calendar" />
                                                                </svg>
                                                                <span className="title"> {this.props.artist.RoleType != 'Fan' ? 'See me' : 'See with me'}</span>
                                                            </Link>
                                                        </li> : null}
                                                    {this.props.artist && ArtistService.showBuyLinks(this.props.artist.RoleType)
                                                    ?
                                                        <li className={this.getTabClass('BuyMe')}>
                                                            <Link id="lnkBuyMe" className="transition" to={this.getTabUrl('BuyMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-buy" />
                                                                </svg>
                                                                <span className="title"> Buy me</span>
                                                            </Link>
                                                        </li> : null}
                                                    {this.props.artist && ArtistService.showFindMe(this.props.artist.RoleType)
                                                    ?
                                                        <li className={this.getTabClass('FindMe')}>
                                                            <Link id="lnkFindMe" className="transition" to={this.getTabUrl('FindMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-location" />
                                                                </svg>
                                                                <span className="title"> Find me</span>
                                                            </Link>
                                                        </li> : null}
                                                    <li className={this.getTabClass('ChatToMe')}>
                                                        <Link id="lnkChatToMe" className="transition"  to={this.getTabUrl('ChatToMe')}>
                                                            <svg className="icon icon-tab transition">
                                                                <use xlinkHref="#icn-chat" />
                                                            </svg>
                                                            <span className="title"> Chat to me</span>
                                                        </Link>
                                                    </li>
                                                    {
                                                        this.showLike() || this.showFollow() ?
                                                            <li className="nav-soc">
                                                                <div className="socbox">
                                                                    {this.showLike() &&                                                
                                                                        <div className="soclink">
                                                                            <span className="soccopy">Like Me</span>
                                                                            <FacebookLike url={this.props.artist.FacebookPageUrl} />
                                                                        </div>
                                                                    }
                                                                    {this.showFollow() &&
                                                                        <div className="soclink">
                                                                            <span className="soccopy">Follow Me</span>
                                                                            <TwitterFollow username={ArtistService.getTwitterUsername(this.props.artist)} />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </li>
                                                            : null
                                                    }
                                                </ul>
                                                <div className="tabcontent">
                                                    <div id="profilecontent" className="tab-pane fade active in">
                                                        {this.props.artist ? this.getTabContent() :null}                                                
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </div>              
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Modal headerText="Inbound connections" type={modalTypes.PLUGGED_IN}>
                            <Connections connections={this.props.artist.ConnectionsInbound} artist={this.props.artist} actions={this.props.actions} user={this.props.user} isPluggedIn={this.isPluggedIn} getPlugInText={this.getPlugInText} getPlugInTooltip={this.getPlugInTooltip} connectDisconnect={this.connectDisconnect} inbound />
                        </Modal>
                        <Modal headerText="Outbound connections" type={modalTypes.PLUGGED_INTO}>
                            <Connections connections={this.props.artist.ConnectionsOutbound} artist={this.props.artist} actions={this.props.actions} user={this.props.user} isPluggedIn={this.isPluggedIn} getPlugInText={this.getPlugInText} getPlugInTooltip={this.getPlugInTooltip} connectDisconnect={this.connectDisconnect} />
                        </Modal>
                        <Modal headerText={this.getConversationModalHeader()} type={modalTypes.CONVERSATION}>
                            <ChatToMeConversation conversation={this.props.artist.Conversation} artist={this.props.artist} actions={this.props.actions} activeProfile={this.props.user ? this.props.user.activeProfile : null} />
                        </Modal>
                    </div>
                : this.getNoProfileComponent()}
            </div>
        );
    }
}

ProfilePage.propTypes = {
    match: PropTypes.object.isRequired,
    artist: PropTypes.object,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object,
    profileLoadingStatus: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    let profileLoadingStatus = state.artists.profileLoadingStatus.find(p => p.username.toLowerCase() == ownProps.match.params.username.toLowerCase());
    return { 
        artist: state.artists.profiles.find(a => a.Username.toLowerCase() == ownProps.match.params.username.toLowerCase()),
        profileLoadingStatus: profileLoadingStatus ? profileLoadingStatus.status : null,
        user: state.account.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistActions, modalActions, trackActions, videoActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);